import { render, staticRenderFns } from "./OrderListDeliveryNew.vue?vue&type=template&id=c0df0a66&scoped=true"
import script from "./OrderListDeliveryNew.vue?vue&type=script&lang=js"
export * from "./OrderListDeliveryNew.vue?vue&type=script&lang=js"
import style0 from "./OrderListDeliveryNew.vue?vue&type=style&index=0&id=c0df0a66&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0df0a66",
  null
  
)

export default component.exports